import ApiClient from '../ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
    constructor() {
        super('', { accountScoped: true });
    }

    index(inboxId) {
        return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates`);
    }

    create(inboxId, data) {
        return axios.post(`${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates`, data);
    }

    sync(inboxId) {
        return axios.post(`${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/sync`);
    }

    delete(inboxId, templateId, templateName) {
        return axios.delete(`${this.baseUrl()}/inboxes/${inboxId}/whatsapp_templates/${templateId}`, {
            params: { template_name: templateName },
        });
    }

    baseUrl() {
        return `${this.apiVersion}/accounts/${this.accountIdFromRoute}`;
    }

    get accountIdFromRoute() {
        return window.location.pathname.match(/accounts\/(\d+)/)?.[1];
    }
}

export default new WhatsappTemplatesAPI();
